if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.resizeImage = this.resizeImage.bind(this);
        this.resizeObserver = new ResizeObserver(this.resizeImage);
        this.resizeObserver.observe(this);
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }


      resizeImage() {
        const activeMedia = this.querySelector('img.active[data-native-width]');
        if (!activeMedia) return;
        activeMedia.loading = 'eager';
        activeMedia.fetchPriority = 'high';
        const ratio = Math.max(1, window.devicePixelRatio || 1);
        const sourceWidth = Number(activeMedia.dataset.nativeWidth);
        const sourceHeight = Number(activeMedia.dataset.nativeHeight);
        const width = Math.min(sourceWidth / ratio, Math.max(1, window.innerWidth - 48), Math.max(1, window.innerHeight - 112) * sourceWidth / sourceHeight);
        activeMedia.style.setProperty('--ughc-zoom-width', width + 'px');
        activeMedia.style.aspectRatio = sourceWidth + ' / ' + sourceHeight;
        activeMedia.style.maxWidth = Math.min(Number(activeMedia.dataset.nativeWidth) / ratio, Math.max(1, window.innerWidth - 48)) + 'px';
        activeMedia.style.maxHeight = Math.min(Number(activeMedia.dataset.nativeHeight) / ratio, Math.max(1, window.innerHeight - 112)) + 'px';
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        this.resizeImage();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = 0;
        container.scrollTop = 0;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
